// extracted by mini-css-extract-plugin
module.exports = {"component":"YoutubeGrid_component__1L_LS","grid":"YoutubeGrid_grid__1kWhs","frame":"YoutubeGrid_frame__KIXDJ"};